<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-06-09 15:43:05
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:25:03
 * @Description: file content
 -->
<template>
  <div class="lucky_stripe">
    <div class="item_warp">
      <img
        @click="clickLucky"
        class="dzp"
        src="https://assets.rurushishi.com/yq-rs-make/components/lucky_stripe/xingyunzhuanpan.png"
        alt
      />
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    clickLucky: function() {
      util.openDraw(
        this,
        "https://henduoke.quanc.com.cn/activities/lotteryDemo/zxdIndexNew.html"
      );
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="css" scoped>
.lucky_stripe {
  position: relative;
}

.lucky_stripe .item_warp:after {
  content: url("https://assets.rurushishi.com/yq-rs-make/components/lucky_stripe/arrow.png?x-oss-process=image/resize,h_20,w_20");
  position: absolute;
  top: 35%;
  right: 20px;
}
.lucky_stripe .item_warp img {
  width: 100%;
}
</style>